import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin, Send, Clock } from 'lucide-react';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 30
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.6,
    ease: 'easeOut'
  }
};
export function Contact() {
  return <main className="pt-32" data-id="element-170">
      <section className="py-16 bg-medical-gray/30 relative overflow-hidden" data-id="element-171">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-20 items-center relative z-10" data-id="element-172">
          <motion.div {...fadeInUp} data-id="element-173">
            <span className="text-medical-red font-heading font-bold uppercase tracking-widest mb-6 block" data-id="element-174">
              Get In Touch
            </span>
            <h1 className="text-5xl md:text-7xl font-heading font-extrabold text-medical-blue mb-8 leading-tight" data-id="element-175">
              Connect With <br data-id="element-176" />
              <span className="text-medical-red italic" data-id="element-177">Our Experts.</span>
            </h1>
            <p className="text-lg md:text-xl text-medical-blue/70 mb-12 leading-relaxed font-medium" data-id="element-178">
              We are here to help you regain control of your health and rebuild
              resilience. Reach out to start your restorative journey.
            </p>

            <div className="space-y-8" data-id="element-179">
              <div className="flex items-center gap-6 group" data-id="element-180">
                <div className="p-4 bg-white rounded-2xl shadow-sm text-medical-red group-hover:bg-medical-red group-hover:text-white transition-all" data-id="element-181">
                  <Mail size={24} data-id="element-182" />
                </div>
                <div data-id="element-183">
                  <p className="text-xs uppercase tracking-widest text-medical-blue/50 font-bold mb-1" data-id="element-184">
                    Email Us
                  </p>
                  <p className="text-xl text-medical-blue font-bold" data-id="element-185">
                    info@globalrestorative.com
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-6 group" data-id="element-186">
                <div className="p-4 bg-white rounded-2xl shadow-sm text-medical-red group-hover:bg-medical-red group-hover:text-white transition-all" data-id="element-187">
                  <Phone size={24} data-id="element-188" />
                </div>
                <div data-id="element-189">
                  <p className="text-xs uppercase tracking-widest text-medical-blue/50 font-bold mb-1" data-id="element-190">
                    Call Us
                  </p>
                  <p className="text-xl text-medical-blue font-bold" data-id="element-191">
                    +1 (555) 000-0000
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-6 group" data-id="element-192">
                <div className="p-4 bg-white rounded-2xl shadow-sm text-medical-red group-hover:bg-medical-red group-hover:text-white transition-all" data-id="element-193">
                  <Clock size={24} data-id="element-194" />
                </div>
                <div data-id="element-195">
                  <p className="text-xs uppercase tracking-widest text-medical-blue/50 font-bold mb-1" data-id="element-196">
                    Availability
                  </p>
                  <p className="text-xl text-medical-blue font-bold" data-id="element-197">
                    Telehealth Services Worldwide
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div {...fadeInUp} className="bg-white p-12 rounded-[60px] shadow-2xl border border-medical-gray relative" data-id="element-198">
            <form className="space-y-8" data-id="element-199">
              <div className="grid md:grid-cols-2 gap-8" data-id="element-200">
                <div className="space-y-2" data-id="element-201">
                  <label className="text-xs uppercase tracking-widest text-medical-blue/60 font-black ml-2" data-id="element-202">
                    Full Name
                  </label>
                  <input type="text" className="w-full bg-medical-gray/20 border-2 border-transparent rounded-2xl px-6 py-4 focus:outline-none focus:border-medical-red transition-all font-semibold" placeholder="John Doe" data-id="element-203" />
                </div>
                <div className="space-y-2" data-id="element-204">
                  <label className="text-xs uppercase tracking-widest text-medical-blue/60 font-black ml-2" data-id="element-205">
                    Email Address
                  </label>
                  <input type="email" className="w-full bg-medical-gray/20 border-2 border-transparent rounded-2xl px-6 py-4 focus:outline-none focus:border-medical-red transition-all font-semibold" placeholder="john@example.com" data-id="element-206" />
                </div>
              </div>
              <div className="space-y-2" data-id="element-207">
                <label className="text-xs uppercase tracking-widest text-medical-blue/60 font-black ml-2" data-id="element-208">
                  Service of Interest
                </label>
                <select className="w-full bg-medical-gray/20 border-2 border-transparent rounded-2xl px-6 py-4 focus:outline-none focus:border-medical-red transition-all font-semibold appearance-none" data-id="element-209">
                  <option data-id="element-210">Family Practice & Wellness</option>
                  <option data-id="element-211">Mental Health Coaching</option>
                  <option data-id="element-212">Professional Training</option>
                  <option data-id="element-213">Consultation Services</option>
                </select>
              </div>
              <div className="space-y-2" data-id="element-214">
                <label className="text-xs uppercase tracking-widest text-medical-blue/60 font-black ml-2" data-id="element-215">
                  Your Message
                </label>
                <textarea rows={4} className="w-full bg-medical-gray/20 border-2 border-transparent rounded-2xl px-6 py-4 focus:outline-none focus:border-medical-red transition-all font-semibold" placeholder="How can we help you?" data-id="element-216" />
              </div>
              <button className="w-full bg-medical-blue text-white py-6 rounded-2xl font-heading font-extrabold text-lg uppercase tracking-widest hover:bg-medical-red transition-all flex items-center justify-center gap-3 shadow-xl shadow-medical-blue/20" data-id="element-217">
                Send Message <Send size={20} data-id="element-218" />
              </button>
            </form>
          </motion.div>
        </div>
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-[0]" data-id="element-219">
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none" className="relative block w-full h-[60px] fill-white" data-id="element-220">
            <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C57.23,107.63,128.3,108.13,201.33,101.86,242.71,98.3,282.73,89.14,321.39,56.44Z" data-id="element-221"></path>
          </svg>
        </div>
      </section>
    </main>;
}